

import styles from './ConfirmLoading.module.scss';
import {FC} from "react";
import {LinearProgress} from "@material-ui/core";
import Pharmacist from "@communicare/medications/Images/pharmacist.svg"
export const ConfirmLoading: FC = ()=>{
    return (
        <div className={styles.body}>
            <img src={Pharmacist} alt='' className={styles.main} />
            <div className={styles.title}>
                Confirming the <em>medications</em>
            </div>
            <div className={styles.info}>We’re confirming your action...</div>
            <LinearProgress color={"primary"} className={styles.progress}/>
        </div>
    );
}